module.exports = __webpack_public_path__ + "img/voucher-redeemed.9001140d.svg";